import React, { Component } from 'react';
import cn from 'classnames';
import { Link as RouterLink } from 'react-router';
import { connect } from 'react-redux';
import { forEach, last } from 'lodash';
import Tabs from 'legacy/src/utility/Tabs';
import btn from 'legacy/src/utility/btn';

import Link from '../../view/Link';
import './workspace.scss';

class PlayerComponent extends Component {
  static displayName = 'Workspace';

  static breakpoints = {
    small: (e) => e.width < 710,
    default: (e) => e.width >= 710,
  };

  constructor(props) {
    super(props);

    this.state = {
      breakpoints: {
        default: true,
      },
    };
  }

  render() {
    const { item, view, childPlayer, path, location, userData } = this.props;
    const breakpoints = this.state.breakpoints;
    const { items } = item.content;
    const currentItem = parseInt(view.current) || 0;
    const panelIndex = items.length - 1;
    let tabs, activeTab;
    if (breakpoints.small) {
      tabs = items;
      activeTab = currentItem;
    } else {
      // Ignore the last item at large sizes, as we display it in the side panel.
      tabs = items.slice(0, -1);
      activeTab = currentItem < items.length - 1 ? currentItem : 0;
    }
    const tabBody = items[activeTab];
    const redirectPath = `${location.pathname}/review/${item.origin.full_path}${location.search}`;

    return (
      <div className={cn('workspace', { workspace__small: breakpoints.small })}>
        <div className="tab_panel">
          <Tabs style="tabs" size="large">
            {tabs.map((item, index) => {
              const props = {
                className: index === activeTab ? 'active' : '',
                view: { [path]: index },
                key: index,
              };
              return <Link {...props}>{item.title}</Link>;
            })}
          </Tabs>

          {/* TODO: This is horrible. We need a better way to inject something to be rendered inside the player that isn't the actual content. */}
          {item.origin && (
            <RouterLink
              to={redirectPath}
              className={cn(
                'view_in_context',
                btn({ style: 'minimal', size: 'small', color: 'gray' }),
              )}
            >
              {userData.isStudent ? 'Quiz View' : 'Student View'}
            </RouterLink>
          )}

          <div className="tab_container">{childPlayer(activeTab, tabBody)}</div>
        </div>
        {breakpoints.default && (
          <div className={cn('panel')}>
            {childPlayer(panelIndex, items[panelIndex])}
          </div>
        )}
      </div>
    );
  }
}

function status(content, state, feedback, children = {}) {
  // This is a fix for a bug where you can't complete a scoring exercise without
  // clicking each tab. A more appropriate fix may be to be able to mark items as
  // "not required". This would make it so that their completion is not tied to
  // viewing them. Switching the default to "not required" may be desirable.
  // The below line seems not to function well after upgrade to @lodash >= 4.10
  // return _.last(_.sortBy(children, (v, k) => k));
  const result = [];
  forEach(Object.keys(children).sort(), (key) => {
    result.push(children[key]);
  });
  return last(result);
}

// TODO: needs responsive element enhancement in here with this?
// const playerComponent = ResponsiveElement(Player);

// export default {playerComponent, status};
function mapStateToProps(state) {
  return {
    userData: state.userData,
  };
}
const Player = connect(mapStateToProps)(PlayerComponent);
export default { Player, status };
